// extracted by mini-css-extract-plugin
export default {"link-container":"link-container--1ds_S","linkContainer":"link-container--1ds_S","icon-row":"icon-row--5N-75","iconRow":"icon-row--5N-75"};